<template>
  <div class="container h-max is-vertical-center has-text-centered">
    <div v-show="step === -1" class="is-uppercase is-fullwidth">
      <div class="fixed-tl is-fullwidth">
        <img v-if="$store.getters.isMH" src="@/../static/muscle_heroes_logo.svg" class="is-inline-block is-xlarge icon" />
        <img v-else src="@/../static/keepyou.fit.svg" class="is-inline-block is-xlarge icon" />
      </div> 
      <img src="@/../static/kfit/sport.png" class="is-inline-block m-t-md" />
      <div style="margin-top: -7.5rem;">
        <p class="is-size-1 has-text-white" style="line-height: 1;">{{ $t('Create your') }}<br>{{ $t('new account') }}</p>
      </div>
      <div class="m-t-lg m-b-lg">
        <button class="p-l-xxl p-r-xxl has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4" @click="onStart">{{ 'Start' | translate }}</button>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step >= 0" class="fixed-tl m-t-md is-fullwidth is-size-4 has-text-primary">
        <img v-if="$store.getters.isMH" src="@/../static/muscle_heroes_logo.svg" class="is-inline-block is-xlarge icon" />
        <img v-else src="@/../static/keepyou.fit.svg" class="is-inline-block is-xlarge icon" />
    </div>
    <div @click="back" v-show="step >= 1" class="fixed-tl m-t-md m-l-sm">
      <img src="@/../static/kfit/arrow_left.svg" class="is-large icon" style="opacity:0.5;">
    </div>
    <div @click="showMenu" v-show="step >= 0" class="fixed-tr m-t-md m-r-sm">
      <img src="@/../static/kfit/menu.svg" class="is-large icon" style="opacity:0.5;">
    </div>
    <div v-show="step === 0" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My name is' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="input profile-input is-size-3" v-model="profile.surname" type="text" :placeholder="$t('Surname').toUpperCase()"></p>
        <p><input class="input profile-input is-size-3" v-model="profile.lastname" type="text" :placeholder="$t('Lastname').toUpperCase()"></p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-3 has-text-primary ' + (hasName ? colorActive : colorInactive)" @click="commitProfile">{{ 'Continue' | translate }}</a>
        <br style="margin-bottom: 2rem;">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 1" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'I\'m a' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><button :class="'button is-size-4 is-rounded-4 has-background-primary has-text-white is-fullwidth profile-input ' + (profile.sex == 'Woman' ? 'has-background-primary has-text-white' : '')" @click="selectOne('sex', 'Woman')">{{ 'Woman' | translate }}</button></p>
        <p><button :class="'button is-size-4 is-rounded-4 has-background-primary has-text-white is-fullwidth profile-input ' + (profile.sex == 'Man' ? 'has-background-primary has-text-white' : '')" @click="selectOne('sex', 'Man')">{{ 'Man' | translate }}</button></p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 2" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My age' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p><input class="slider is-fullwidth profile-input is-medium is-circle" step="1" min="10" max="100" value="25" type="range" v-model="profile.age"></p>
        <p class="has-text-right is-size-3 has-text-primary">{{ profile.age || 25 }} {{ 'years old' | translate }}</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-3 has-text-primary ' + (isAbove0('age') ? colorActive : colorInactive)" @click="selectOne('age', parseInt(profile.age))">{{ 'Continue' | translate }}</a>
        <br style="margin-bottom: 2rem;">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 3" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My height' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p class="is-size-3"><input class="input profile-input is-size-3"  type="number" v-model="profile.height" style="width: 7rem;"> cm</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-3 has-text-primary ' + (isAbove0('height') ? colorActive : colorInactive)" @click="selectOne('height', parseInt(profile.height))">{{ 'Continue' | translate }}</a>
        <br style="margin-bottom: 2rem;">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 4" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My weight' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <p class="is-size-3"><input class="input profile-input is-size-3"  type="number" v-model="profile.weight" style="width: 7rem;"> kg</p>
      </div>
      <div class="fixed-bl is-fullwidth">
        <a :class="'link is-size-3 has-text-primary ' + (isAbove0('weight') ? colorActive : colorInactive)" @click="selectOne('weight', parseInt(profile.weight))">{{ 'Continue' | translate }}</a>
        <br style="margin-bottom: 2rem;">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 5" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My body' | translate }}</div>
      <div class="m-t-md m-b-lg">
        <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.body == 'Skinny' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Skinny')">{{ 'BRSkinny' | translate }}</button><br>
        <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.body == 'Average' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Average')">{{ 'BRAverage' | translate }}</button><br>
        <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.body == 'Corpulent' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Corpulent')">{{ 'BRCorpulent' | translate }}</button><br>
        <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.body == 'Muscular' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('body', 'Muscular')">{{ 'BRMuscular' | translate }}</button><br>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <div v-show="step === 6" class="section is-uppercase is-fullwidth">
      <div class="is-mobile is-size-1 has-text-white">{{ 'My goal' | translate }}</div>
      <div class="m-t-md m-b-lg">
          <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.goal == 'Health' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Health')">{{ 'BRHealth' | translate }}</button><br>
          <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.goal == 'Endurance' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Endurance')">{{ 'BREndurance' | translate }}</button><br>
          <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.goal == 'Appearance' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Appearance')">{{ 'BRAppearance' | translate }}</button><br>
          <button :class="'cp-list has-text-weight-bold button has-background-primary is-size-4 has-text-white is-rounded-4 ' + (profile.goal == 'Strength' ? 'has-background-primary has-text-white' : 'has-background-white')" @click="selectOne('goal', 'Strength')">{{ 'BRStrength' | translate }}</button>
      </div>
      <div class="fixed-bl is-fullwidth">
        <Footer/>
      </div>
    </div>
    <ProfileMenu ref="menu" :show="show" v-on:go="go" />
  </div>
</template>

<script>
import axios from 'axios'
import Footer from '@/components/LangKyf/Footer'
import ProfileMenu from '@/components/ProfileMenu'

export default {
  name: 'CreateProfile',
  data () {
    return {
      start: false,
      colorActive: this.$store.isMH ? 'has-text-grey-darker' : 'has-text-white',
      colorInactive: 'has-text-grey-light',
      profile: {
        surname: null,
        lastname: null,
        sex: null,
        age: null,
        height: null,
        weight: null,
        body: null,
        goal: null
      },
      step: -1,
      show: false
    }
  },
  computed: {
    hasName() {
      return typeof this.profile.surname === 'string' && typeof this.profile.lastname === 'string' && this.profile.surname.length > 0 && this.profile.lastname.length > 0
    }
  },
  methods: {
    onStart() {
      this.step = 0
    },
    back() {
      this.step--
    },
    go(n) {
      this.step = n
    },
    selectOne(key, val) {
      this.profile[key] = val
      this.commitProfile()
    },
    commitProfile() {
      this.$store.dispatch('updateProfile', this.profile)
      this.step++
      if (this.step > 6) {
        this.$router.push({ name: 'Home' })
      }
    },
    isAbove0(key) {
      return parseInt(this.profile[key]) > 0
    },
    showMenu() {
      this.$refs.menu.showMe()
    }
  },
  async mounted() {
    if (this.$store.getters.requireSaleId && window !== undefined && window.localStorage instanceof Storage && window.localStorage.getItem('saleId') !== null) {
      const result = await axios.get(`/${ this.$store.getters.apiPrefix }/checkSale/${ window.localStorage.getItem('saleId') }`)
      if (result.data.state === 'unknown') {
        this.$router.push({ name: 'LP' })
      }
    } 
  },
  components: {
    Footer,
    ProfileMenu
  }
}
</script>

<style>
    .profile-input {
      text-align: center;
      margin-bottom: 0.4em;
      background: transparent;
      color: #48b89e;
    }
    .profile-box-group {
      position: relative;
      width: 14rem;
      height: 7rem;
      margin: auto;
    }
    input[type="range"].slider.is-medium:not([orient="vertical"])::-webkit-slider-runnable-track,
    input[type="range"].slider.is-medium:not([orient="vertical"])::-moz-range-track,
    input[type="range"].slider.is-medium:not([orient="vertical"])::-ms-track
    {
        height: 0.2rem !important;
    }
    .cp-list {
      min-width: 320px;
      margin: 0.4rem;
    }
</style>



// WEBPACK FOOTER //
// src/components/LangKyf/TH/CreateProfile.vue